import AbstractModule from './AbstractModule';
import {selectricDecorator} from '../ractive/ractive-decorators-selectric';
import tap from '../ractive/ractive-events-tap';
import fade from '../ractive/ractive-transitions-fade';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.lang = options.lang || 'en';

        this.fetchingTemplate = false;
        this.template = false;
        this.partials = false;
        this.gender = options.gender;

        this.filters = false;

        this.$dom = {};

        this.init();
    }

    init() {
        //this.$dom.select = this.$el.find('.js-select');
        this.$dom.years = this.$el.find('.js-calendar-year');
        this.$dom.form = this.$el.find('.js-calendar-form');
        this.$dom.start = this.$el.find('.js-calendar-date-start');
        this.$dom.end = this.$el.find('.js-calendar-date-end');

        // events
        this.$el.on('click.SelectCalendar', '.js-calendar-label', event => {
            event.preventDefault();
            this.open();
        });
        this.$el.on('change.SelectCalendar', '.js-calendar-item', event => {
            event.preventDefault();
            this.changeValue(event);
        });
        this.$el.on('change.SelectCalendar', '.js-calendar-year', event => {
            event.preventDefault();
            this.selectYear(event);
        });

        this.fetchTemplate();
    }

    getMonth(month, locale) {
        const months = [];
        months['fr'] = [
            'Janvier', 'Fevrier', 'Mars', 'Avril',
            'mai', 'Juin', 'Juillet', 'Aout',
            'Septembre', 'Octobre', 'Novembre', 'Decembre'
        ];
        months['en'] = [
            'January', 'February', 'March', 'April',
            'May', 'June', 'July', 'August',
            'September', 'October', 'November', 'December'
        ];

        return months[locale][month - 1];
    }

    selectYear(event) {
        const $el = $(event.target).find(':selected');
        if ($el.val()) {
            this.fetchFilters({
                'year' : $el.val(),
                'gender' : this.gender
            });
        }
        this.$dom.years.not($el).removeClass('is-current');
        $el.addClass('is-current');
    }

    selectValue(value) {
        const start = value.split(',').shift();
        const end = value.split(',').pop();

        // Trigger the event list modifications.
        this.$document.trigger('update.EventList', {
            fromDate : start,
            toDate : end
        });

        // afficher les nouvelles dates
        this.$dom.start.text(start.split('-')[2] + ' ' + this.getMonth(parseInt(start.split('-')[1]), this.lang)); // TODO changer la langue
        this.$dom.end.text(end.split('-')[2] + ' ' + this.getMonth(parseInt(end.split('-')[1]), this.lang)); // TODO changer la langue

        // mise à jour du form select
        this.$dom.form.val(value).change();

        // fermer le selecteur
        this.close();
    }

    changeValue(event) {
        const value = $(event.target).find(':selected').val();
        this.selectValue(value);
    }

    /**
     * When filters are loaded.
     * @return {[type]} [description]
     */
    filtersLoaded() {
        if (!this.filters) {
            return this;
        }

        if (!this.ractiveInstance) {
            this.initRactive();
            return this;
        }

        this.ractiveInstance.set('filters', this.filters).then(() => {
            this.selectValue(this.$el.find('.js-calendar-filters').find(':selected').val());
            $('.js-calendar-filters').selectric('refresh');
        });
        return this;
    }

    /**
     * Inits ractive and set calendar events if already specified.
     * @return {[type]} [description]
     */
    initRactive() {
        if (!this.template && !this.fetchingTemplate) {
            this.fetchTemplate(() => { this.initRactive() });
            return this;
        }

        let data = {
            filters: [],
            loading    : true
        };
        if (this.filters) {
            data = {
                filters : this.filters,
                loading : false
            }
        }
        let domList = this.$el.find('.js-calendar-filters');
        this.ractiveInstance = new Ractive({
            el         : domList,
            template   : this.template,
            partials   : this.partials,
            events     : {tap},
            transitions: {fade},
            decorators : {
                selectric: selectricDecorator
            },

            data    : data,
            onrender: () => {
                // self.loaded();
                this.selectValue(this.$el.find('.js-calendar-filters').find(':selected').val());
                $('.js-calendar-filters').selectric('refresh');
            }
        });
    }

    /**
     * Get the required template for the list.
     * @param  {Function} cb [description]
     * @return {[type]}      [description]
     */
    fetchTemplate(cb) {
        if (this.fetchingTemplate || this.template) {
            return this;
        }

        this.fetchingTemplate = true;

        $.get('template', {template: 'volleyball/template/partial/components/topbar/topbar-calendar-week-filters'}, (response) => {
            if (response.success) {
                this.template = response.template;
                this.partials = response.partials;
                if (typeof cb === 'function') {
                    cb();
                }
            }
            this.fetchingTemplate = false;
        }, 'json');

        return this;
    }


    /**
     * From date to date with gender
     * @param  {[type]} opts [description]
     * @return {[type]}      [description]
     */
    fetchFilters(data) {

        $.get('event-filters', data, (response) => {
            if (response.success) {
                this.filters = response.filters;
                this.filtersLoaded();
            } else {
                this.error(response);
            }
        }, 'json')
    }

    error(response) {
        console.debug(response);
    }

    open() {
        this.$el.addClass('is-opened');
    }

    close() {
        this.$el.removeClass('is-opened');
    }

    destroy() {
        this.$el.off('.SelectCalendar');

        this.$dom = {};
    }
}
